import { Injectable } from '@angular/core';
import { DateUtil } from '../util/date-util';

/**
 * ローカルストレージサービス.
 */
@Injectable()
export class LocalStorageService {

  /**
   * コンストラクタ.
   */
  constructor() { }

  /**
   * ローカルストレージにデータを保存します.
   *
   * @param key 保存したいキー値
   * @param val 保存したい値（任意の型で可）
   */
  save<T>(key: string, val: T): void {
    localStorage.setItem(key, JSON.stringify(val));
  }

  /**
   * ローカルストレージからデータを取得します.
   *
   * @param key 取得したいキー値
   */
  load<T>(key: string): T {
    return JSON.parse(localStorage.getItem(key));
  }

  /**
   * ローカルストレージからデータを削除します.
   *
   * @param key 削除したいキー値
   */
  remove(key: string): void {
    localStorage.removeItem(key);
  }

  /**
   * ローカルストレージから指定された日数より過去の訪問年月日のデータを削除します（KVA専用）.
   *
   * KVAでは、ローカルストレージのキーは以下のフォーマットに統一している．
   * グループ会社コード（SLI固定）＋訪問年月日（YYYYMMDD）＋相手先コード＋任意キー
   * 例）SLI201805312222222222SaveData
   * ローカルストレージのキーの訪問年月日部分が、引数の基準日と比較して指定された日数より過去のデータを削除する．
   * 例）基準日を2018/5/16とし、removeOldData('20180516', 3) を実行すると、2018/5/12以前のものが削除される。
   *
   * @param baseDate 基準日（当日）を表す日付文字列（YYYYMMDD）
   * @param days 日数（自然数（1,2,3,...）を指定すること）
   */
  removeOldData(baseDate: string, days: number): void {
    const referenceDate: Date = DateUtil.adjustWithDays(DateUtil.parseYYYYMMDD(baseDate), -days);
    for (const key in localStorage) {
      if (key.startsWith('SLI') && key.length > 11) {
        const deliveryDate: Date = DateUtil.parseYYYYMMDD(key.substring(3, 11));
        if (deliveryDate < referenceDate) {
          localStorage.removeItem(key);
        }
      }
    }
  }

  /**
   * ローカルストレージから全データを削除します.
   */
  clearAll(): void {
    localStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/app/common-app/service/local-storage.service.ts